var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgKreuz01 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "133.8 62.1 651.1 651.1",
    enableBackground: "new 133.8 62.1 651.1 651.1",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B41622",
    d: "M784.9,586c0,14.6-5.1,27-15.3,37.3L695,697.9c-10.2,10.2-22.7,15.3-37.3,15.3c-14.6,0-27-5.1-37.3-15.3 L459.4,536.7L298.2,697.9c-10.2,10.2-22.7,15.3-37.3,15.3c-14.6,0-27-5.1-37.3-15.3l-74.5-74.5c-10.2-10.2-15.3-22.7-15.3-37.3 c0-14.6,5.1-27,15.3-37.3l161.1-161.1L149.1,226.5c-10.2-10.2-15.3-22.7-15.3-37.3c0-14.6,5.1-27,15.3-37.3l74.5-74.5 c10.2-10.2,22.7-15.3,37.3-15.3c14.6,0,27,5.1,37.3,15.3l161.1,161.1L620.5,77.4c10.2-10.2,22.7-15.3,37.3-15.3 c14.6,0,27,5.1,37.3,15.3l74.5,74.5c10.2,10.2,15.3,22.7,15.3,37.3c0,14.6-5.1,27-15.3,37.3L608.4,387.6l161.1,161.1 C779.8,559,784.9,571.4,784.9,586z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgKreuz01, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/kreuz-01.395f03ef.svg";
export { ForwardRef as ReactComponent };